import { handleActions } from 'redux-actions';
import {
  setLoaded,
  setLoading,
  setDirection,
  setLanguage,
} from './action';

const DEFAULT_STATE = {
  loading: true,
  loaded: false,
  // direction: RTL_DIRECTION[i18n.language.substring(0,2)] ? 'rtl' : 'ltr',
  // language: i18n.language.substring(0,2),
};

const handlers = {
  [setLoading]: (state, action) => ({ ...state, loading: !!action.payload }),
  [setLoaded]: (state, action) => ({ ...state, loaded: action.payload }),
  [setDirection]: (state, action) => ({ ...state, direction: action.payload }),
  [setLanguage]: (state, action) => ({ ...state, language: action.payload }),
};

export default handleActions(handlers, DEFAULT_STATE);
